import { render, staticRenderFns } from "./ProviderCardOld.vue?vue&type=template&id=1714d688&scoped=true"
import script from "./ProviderCardOld.vue?vue&type=script&lang=js"
export * from "./ProviderCardOld.vue?vue&type=script&lang=js"
import style0 from "./ProviderCardOld.vue?vue&type=style&index=0&id=1714d688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1714d688",
  null
  
)

export default component.exports